// extracted by mini-css-extract-plugin
export default {"metrics":"styles_metrics__9Aey3","metrics__grid":"styles_metrics__grid__s-Ui8"};